module.exports.menuScroll = () => {
    const navBar = document.querySelector('nav.navbar')
    let lastScrollTop = 0

    document.addEventListener(
        'scroll',
        function () {
            var st = window.pageYOffset || document.documentElement.scrollTop
            scrolled()
            lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
        },
        false
    )

    function scrolled() {
        let scrollPosition = window.scrollY

        if (scrollPosition > 300) {
            navBar.classList.add('nav-float')
            navBar.classList.add('nav-float-show')
        } else {
            navBar.classList.remove('nav-float-show')
            navBar.classList.remove('nav-float')
        }
    }
}
